import { createSelector } from 'reselect';
import { selectOfferGeo } from './selectOfferGeo';
import { IAppState } from '../../../AppModulesWrapper';

export const selectOfferAddress = createSelector(
  [(state: IAppState) => selectOfferGeo(state)],
  (geo): string | undefined => {
    return geo?.userInput;
  },
);
